// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#trial-heatmap-grid {\n\tmargin: unset;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Content/Trials/TrialHeatmap/styles.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd","sourcesContent":["#trial-heatmap-grid {\n\tmargin: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trial-heatmap-grid": "trial-heatmap-grid"
};
export default ___CSS_LOADER_EXPORT___;
